import { styled, RadioGroup as RadioGroup$1 } from "@mui/material";
const RadioGroup = styled(RadioGroup$1)(
  ({ theme, direction = "column" }) => ({
    background: theme.palette.common.white,
    borderRadius: "4px 4px 0 0",
    width: "100%",
    flexDirection: direction,
    flexWrap: direction === "row" ? "nowrap" : "wrap"
  })
);
export {
  RadioGroup
};
